// src/utils/timeAgo.js
// ✅ STRICT: Only epoch seconds allowed
// ❌ MySQL / ISO string dates are NOT parsed (prevents timezone mismatch)

export function parseToDate(input) {
  if (input === null || input === undefined || input === "") return null;

  let epochSec;

  // number epoch
  if (typeof input === "number" && Number.isFinite(input)) {
    epochSec = input;
  }
  // numeric string epoch
  else if (typeof input === "string" && /^\d+$/.test(input)) {
    epochSec = Number(input);
  }
  // ❌ any other string is rejected
  else {
    return null;
  }

  if (!Number.isFinite(epochSec)) return null;

  const d = new Date(epochSec * 1000);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function timeAgo(input) {
  const date = parseToDate(input);
  if (!date) return "";

  const diffSeconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diffSeconds < 0) return "";

  if (diffSeconds < 60) return "just now";

  const minutes = Math.floor(diffSeconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;

  const years = Math.floor(months / 12);
  return `${years}y ago`;
}
